import React, { createContext, useState } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [tbsUser, setTbsUser] = useState(null);
  const [customerId, setCustomerId] = useState(null);

  return (
    <AuthContext.Provider value={{ tbsUser, setTbsUser, customerId, setCustomerId }}>
      {children}
    </AuthContext.Provider>
  );
};
